//header - line centered behind text
export const SectionHeader = ({text, stylesOverride}) => {
  //local styles for component
  let styles = {
    container: {
      width: "100%",
      paddingTop: "2px"
    },
    text: {
      fontSize: "12px",
      color: "#666666",
      padding: "0 6px",
      marginLeft: "8px", 
      backgroundColor: "#FFF", //bg covers line
      zIndex: "1",
      position: "relative",
      width: "fit-content",
    },
    line: { 
      borderBottom: "1px solid #e0e0e0",
      transform: "translateY(-8px)",
      zIndex: "0"
    }
  }
  if (stylesOverride && stylesOverride.container) styles.container = stylesOverride.container;
  if (stylesOverride && stylesOverride.text) styles.text = stylesOverride.text;
  if (stylesOverride && stylesOverride.line) styles.line = stylesOverride.line;
  
  return (
    <div style={styles.container}>
      <div style={styles.text}>{text}</div>
      <div style={styles.line}></div>
    </div>
  )
}